import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import teamService from "./teamService";

export const getTeams = createAsyncThunk("team/getAll", async (_, thunkAPI) => {
  try {
    return await teamService.fetchTeams();
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message);
  }
});

const teamSlice = createSlice({
  name: "team",
  initialState: {
    teams: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTeams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTeams.fulfilled, (state, action) => {
        state.loading = false;
        state.teams = action.payload;
      })
      .addCase(getTeams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default teamSlice.reducer;
